<ng-container>
	<mat-card style="margin:20px;">
		<mat-card-header>
			<div style="font-size: 32px;font-weight: 900;" translate>問い合わせ</div>
		</mat-card-header>
		<mat-card-content>
			<div fxLayout="row" fxLayoutAlign="start">
				<mat-paginator #paginator (page)="Page($event)" [length]="count" [pageSize]="size">
				</mat-paginator>
			</div>
			<mat-grid-list (window:resize)="onResize($event)" [cols]="breakpoint" rowHeight="1:1">
				<mat-grid-tile *ngFor="let inquiry of results" [colspan]="inquiry.cols" [rowspan]="inquiry.rows" class="box-body">

					<mat-grid-tile-header *ngIf="inquiry.status === 0" fxLayout="column" matTooltip="{{inquiry.question | truncate: 100}}" style="background-color: #e98282">
						<div class="box-header" style="font-size: 12px;">
							{{inquiry.username | truncate: 20}}
						</div>
					</mat-grid-tile-header>

					<mat-grid-tile-header *ngIf="inquiry.status === 1" fxLayout="column" matTooltip="{{inquiry.question | truncate: 100}}" style="background-color: #a0a0a0">
						<div class="box-header" style="font-size: 12px;">
							{{inquiry.username | truncate: 20}}
						</div>
					</mat-grid-tile-header>

					<div fxLayout="column">
						<div class="box-text-question" matTooltip="{{inquiry.question | truncate: 320}}">{{inquiry.question | truncate: 76}}</div>
						<div class="box-text-answer" matTooltip="{{inquiry.answer | truncate: 320}}">{{inquiry.answer | truncate: 76}}</div>
					</div>

					<mat-grid-tile-footer fxLayout="row" fxLayoutAlign="space-around center">
						<button (click)="updateDialog(inquiry.id)" mat-icon-button id="mat-edit-button">
							<mat-icon color="primary">edit</mat-icon>
						</button>
						<button (click)="onDelete($event, inquiry.id)" mat-icon-button id="mat-delete-button">
							<mat-icon color="warn">delete_sweep</mat-icon>
						</button>
					</mat-grid-tile-footer>
				</mat-grid-tile>
			</mat-grid-list>
		</mat-card-content>
	</mat-card>
</ng-container>
